import styled from 'styled-components';

export const ContentWrap = styled.div`
  margin: 2rem -1rem;
  & > div {
    padding: 0 1rem;
    margin-bottom: 2rem;
  }
`;
